import React from 'react';

// Darker text on a lighter tint of the same hue, rounded pill, no hover effect.
const TONE_CLASSES = {
  success: 'bg-emerald-100 text-emerald-700',
  warning: 'bg-amber-100 text-amber-700',
  danger: 'bg-accent-100 text-accent-700',
  neutral: 'bg-slate-100 text-slate-600',
};

const STATUS_TONES = {
  active: 'success',
  approved: 'success',
  completed: 'success',
  close: 'success',
  closed: 'success',
  qualified: 'success',
  paid: 'success',

  pending: 'warning',
  'pending review': 'warning',
  'pending-review': 'warning',
  draft: 'warning',
  inprogress: 'warning',
  'in progress': 'warning',
  'in-progress': 'warning',
  spareout: 'warning',
  'on hold': 'warning',
  'on-hold': 'warning',
  dormant: 'warning',
  other: 'warning',

  inactive: 'danger',
  unapproved: 'danger',
  rejected: 'danger',
  blocked: 'danger',
  discontinued: 'danger',
  cancelled: 'danger',
  blacklisted: 'danger',
  open: 'danger',
};

/** Maps a status string (any case/spacing) to a semantic tone; unknown statuses fall back to neutral gray. */
export function getStatusTone(status) {
  const key = String(status ?? '').trim().toLowerCase();
  return STATUS_TONES[key] || 'neutral';
}

/** Tailwind classes for a status pill — reused by places that can't render <StatusBadge> directly (e.g. a toggle <button>). */
export function statusBadgeClassName(status, tone) {
  const resolved = tone || getStatusTone(status);
  return `inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${TONE_CLASSES[resolved]}`;
}

/**
 * Status pill for DataTable columns — green for active/approved/completed states,
 * amber for pending/in-progress states, red for rejected/unapproved/inactive states.
 * Pass `as="button"` (plus onClick/title) for a clickable status toggle.
 */
export function StatusBadge({ status, label, tone, as: Component = 'span', className = '', ...props }) {
  return (
    <Component className={`${statusBadgeClassName(status, tone)} ${className}`} {...props}>
      {label ?? status}
    </Component>
  );
}

export default StatusBadge;
